import {animated, useSpring} from '@react-spring/web';
import React from 'react';

export const AnimSpeed = ({
    visible,
    duration = 200,
    color = '#0ea5e9',
}: {
    visible: boolean;
    duration?: number;
    color?: string;
}) => {
    const scaleStyle = useSpring({
        config: {duration: duration * 0.5},
        transform: visible ? 'scale(1)' : 'scale(0)',
        opacity: visible ? 1 : 0,
    });

    // Cast animated.div to a generic React component to satisfy TypeScript children/props typing
    const AnimatedDiv = animated.div as unknown as React.ComponentType<any>;

    return (
        <div className="w-full h-full flex items-center justify-center">
            <AnimatedDiv style={scaleStyle} className="relative">
                <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M 10 2 L 4 9 L 8 9 L 6 14 L 12 7 L 8 7 L 10 2"
                        fill={color}
                        stroke="none"
                    />
                </svg>
            </AnimatedDiv>
        </div>
    );
};
